<template>
	<div class="remain-modal">
        <table class="remain-table"  >
            <thead>
                <tr>
                    <td style="width:135px;">日期</td>
                    <td style="width:85px;">库存</td>
                    <td style="width:125px;">房价/间/晚</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="rate in DailyRates">
                    <td>{{rate.DateStr}}</td>
                    <td>
                        <span class="little" v-if="rate.Stock>=5&&Tip!=6">房量充足</span>
                        <span class="little" v-if="rate.Stock<5&&rate.Stock>0&&Tip!=6">仅剩{{rate.Stock}}间</span>
                        <span class="little" v-if="!rate.Stock&&IsAskRoom">等待确认</span>
                        <span class="little" v-else-if="!rate.Stock">售罄</span>
                    </td>
                    <td><span class="price">{{Currency}} {{rate.TotalAmount||rate.AvgPrice||rate.AdultPrice}}</span></td>
                </tr>
        		<tr v-for="item in price.Surcharges" v-if="price.Surcharges&&price.Surcharges.length>0&&!item.IncludeInPrice">
                    <td colspan="3">
                        <!-- 另包含税/费  -->
                        {{item.Name+'(酒店到付)'}}：
                        <span class="price">{{item.Currency}} {{item.Price}}</span>
                    </td>
                </tr>
                <tr v-if="price.TotalTaxAndFeeAmount">
                    <td colspan="3">
                        TaxAndFee：
                        <span class="price">{{Currency}} {{price.TotalTaxAndFeeAmount}}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">总价：
                        <span class="price">{{Currency}} {{(From==1?price.AdultPrice:price.Price)}}</span>
                          (
                          {{RoomCount}}
                          间
                          {{getDays(CheckIn,CheckOut)}}晚
                          )
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
	
</template>

<script>
	export default{
		name:'daily-rate',
		props:{
			DailyRates:{
				type:Array,
                default: () => {
                    return []
                }
			},
			price:{
				type:Object,
                default: () => {
                    return {}
                }
			},
            IsAskRoom:{
                type:Boolean,
                default:false
            },
            Tip:{
                type:Number,
                default:0
            },
			From:{
				type:Number,
				default:1
			},
			RoomCount:{
				type:Number,
				default:1
			},
			CheckIn:{
				type:String,
				default:''
			},
			CheckOut:{
				type:String,
				default:''
			}
		},
        data(){
            return{
                Currency: this.dao.get('userInfo').Currency,
            }
        },
        mounted() {
			var that = this
			that.$nextTick(() => {
				if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }    
			})
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/dailyRate/dailyRate.vue